import { render } from "./ContactoFormPage.vue?vue&type=template&id=0a249483&scoped=true"
import script from "./ContactoFormPage.vue?vue&type=script&lang=js"
export * from "./ContactoFormPage.vue?vue&type=script&lang=js"

import "./ContactoFormPage.vue?vue&type=style&index=0&id=0a249483&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a249483"]])

export default __exports__